import {AddIcon, ThemeProvider} from '../../../ui-library';
import {ButtonsBox, StartBtn, AcIcon, CoupleBox, ObjectsTitle, AddObjectBtn, RandomBtn} from '../Style/CreateAutoProjectButtons.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import React from 'react';
import useCreateAutoProjectButtons from '../Controller/CreateAutoProjectButtons.controller';
import {IPropsView} from '../Config/CreateAutoProjectButtons.config';
import CreateAutoProjectConfirmationView from '../../CreateAutoProjectConfirmation/View/CreateAutoProjectConfirmation.view';

import BowserPopupNavigation from '../../../HOC/BowserPopupNavigation';
import useCreateAutoProjectConfirmation from '../../CreateAutoProjectConfirmation/Controller/CreateAutoProjectConfirmation.controller';

const CreateAutoProjectConfirmationWrapper = BowserPopupNavigation(CreateAutoProjectConfirmationView);
const CreateAutoProjectButtonsView = ({autoProjectState, editDraftAutoProject, initialNewAutoProject, setState, navigateToDataProjects, runAutoClassifier, navigateToAutoStatusPage, chosenTags = [], setOpenModal}:IPropsView) => {
    const {handleSaveBtnClick, handleOpenConfirmBtnClick, isDisabled, goBackToRandomSampler} = useCreateAutoProjectButtons(autoProjectState, editDraftAutoProject, initialNewAutoProject, setState, navigateToDataProjects, runAutoClassifier, navigateToAutoStatusPage, chosenTags);
    const {handleExitModal} = useCreateAutoProjectConfirmation(setState);

    return (
        <ThemeProvider>
            <ButtonsBox>
                <CoupleBox>
                    <ObjectsTitle>Objects list </ObjectsTitle>
                    <AddObjectBtn
                        variant='outlined'
                        onClick={() => (setOpenModal ? setOpenModal(true) : null)}
                    >
                        <AddIcon fontSize={'small'}/>
                    </AddObjectBtn>
                </CoupleBox>
                <CoupleBox>
                    <RandomBtn
                        variant='outlined'
                        size='large' disabled={!autoProjectState.isRandomBtn}
                        onMouseDown={() => autoProjectState.isRandomBtn && goBackToRandomSampler()}>{_SYSTEM_TITLES.randomImagesBtnTitle}</RandomBtn>
                    <StartBtn disabled={!chosenTags.length} variant='contained' size='large' onMouseDown={handleOpenConfirmBtnClick}><AcIcon/> {_SYSTEM_TITLES.autoProjectStartBtn}</StartBtn>
                </CoupleBox>
                <CreateAutoProjectConfirmationWrapper
                    open={autoProjectState.openCreateProjectModal}
                    isDisabled={isDisabled}
                    onClose={handleExitModal}
                    bowsernavkey='modal-auto-create-0'
                    autoProjectState={autoProjectState}
                    handleSaveBtnClick={handleSaveBtnClick}
                    chosenTags={chosenTags}
                    setState={setState}/>
            </ButtonsBox>
        </ThemeProvider>
    );
};

export default CreateAutoProjectButtonsView;
